import axios from "axios";
import { IInvoiceApi } from "./IInvoiceApi";
import { IResult } from "../../../Models/Result/IResult";
import { IInvoiceItemList } from "../../../Models/Invoice/IInvoiceList";
import { IInvoiceFilter } from '../../../Models/Invoice/IInvoiceFilter';
import { IEditInvoice } from '../../../Models/Invoice/IEditInvoice';
import { formatUrl, handleError } from "../ApiHelpers";
import { Result } from "../../../Models/Result/Result";
import { ICreateInvoiceFromRegistration } from '../../../Models/Invoice/ICreateInvoiceFromRegistration';
import { IInvoice } from "../../../Models/Invoice/IInvoice";
import { IInvoiceItem } from "../../../Models/Invoice/IInvoiceItem";
import { strToDate } from "../../../Tools/DateTime";

export class InvoiceApi implements IInvoiceApi {

    private backendUrl: string;

    constructor(url: string) {
        this.backendUrl = url;
    } 

    async findInvoices(filter: IInvoiceFilter): Promise<IResult<IInvoiceItemList[]>> {
        try {
            var f = "";
            if (filter.id != undefined && filter.id !== 0) {
                f = f + (f != "" ? "&" : "?") + `Id=${filter.id}`;
            }
            if (filter.year != undefined && filter.year !== 0) {
                f = f + (f != "" ? "&" : "?") + `year=${filter.year}`;
            }
            if (filter.onlyOverDue===true) {
                f = f + (f != "" ? "&" : "?") + `onlyOverDue=${filter.onlyOverDue}`;
            }
            if (filter.onlyUnpaied === true) {
                f = f + (f != "" ? "&" : "?") + `onlyUnpaied=${filter.onlyUnpaied}`;
            }
            if (filter.onlyStorno === true) {
                f = f + (f != "" ? "&" : "?") + `onlyStorno=${filter.onlyStorno}`;
            }
            if (filter.orderId != undefined && filter.orderId !== 0 ) {
                f = f + (f != "" ? "&" : "?") + `orderId=${filter.orderId}`;
            }

            if (filter.registrationId != undefined && filter.registrationId !== 0) {
                f = f + (f != "" ? "&" : "?") + `registrationId=${filter.registrationId}`;
            }

            if (filter.userId != undefined && filter.userId !== "") {
                f = f + (f != "" ? "&" : "?") + `userId=${filter.userId}`;
            }
            if (filter.userName != undefined && filter.userName !== "") {
                f = f + (f != "" ? "&" : "?") + `userName=${filter.userName}`;
            }
            if (filter.variabil != undefined && filter.variabil!== "") {
                f = f + (f != "" ? "&" : "?") + `variabil=${filter.variabil}`;
            }

            const url = formatUrl(this.backendUrl, `/api/Invoice/GetInvoicesByFilter` + f);
            const response = await axios.get(url);
            const res = response.data as IResult<IInvoiceItemList[]>;
            if (res.isSuccess && res.data) {
                res.data.forEach(function (part, index) {
                    if (res.data) {
                        res.data[index].created = strToDate(part.created.toString());   
                        res.data[index].due = strToDate(part.due.toString());
                        res.data[index].uskut = strToDate(part.uskut.toString());
                        res.data[index].paid = strToDate(part.paid.toString());  
                    }
                }, res.data);
                return Result.ok(res.data);
            }
            return response.data as IResult<IInvoiceItemList[]>;
        }
        catch (error) {
            return handleError(error, "GetEventByFilterQuery");
        }
    }

    async getInvoicesByUserId(onlyUnpaied?: boolean, onlyOverDue?: boolean): Promise<IResult<IInvoiceItemList[]>> {
        try {
            var f = "";

            if (onlyOverDue === true) {
                f = f + (f != "" ? "&" : "?") + `onlyOverDue=${onlyOverDue}`;
            }
            if (onlyUnpaied === true) {
                f = f + (f != "" ? "&" : "?") + `onlyUnpaied=${onlyUnpaied}`;
            }
            const url = formatUrl(this.backendUrl, `/api/Invoice/GetInvoicesByUserId` + f);
            const response = await axios.get(url);
            const res = response.data as IResult<IInvoiceItemList[]>;
            if (res.isSuccess && res.data) {
                res.data.forEach(function (part, index) {
                    if (res.data) {
                        res.data[index].created = strToDate(part.created.toString());
                        res.data[index].due = strToDate(part.due.toString());
                        res.data[index].uskut = strToDate(part.uskut.toString());
                        res.data[index].paid = strToDate(part.paid.toString());
                    }
                }, res.data);
                return Result.ok(res.data);
            }
            return response.data as IResult<IInvoiceItemList[]>;
        }
        catch (error) {
            return handleError(error, "getInvoicesByUserId");
        }
    }

    async getInvoice(id: number): Promise<IResult<IInvoice>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/Invoice/GetInvoice/${id}`);
            const response = await axios.get(url);
            const res = response.data as IResult<IInvoice>;
            if (res.isSuccess && res.data) {

                res.data.created = strToDate(res.data.created.toString());
                res.data.due = strToDate(res.data.due.toString());
                res.data.uskut = strToDate(res.data.uskut.toString());
                if (res.data.maxPaidDate) {
                    res.data.maxPaidDate = strToDate(res.data.maxPaidDate.toString()); 
                }
            }
           return Result.ok(res.data);
        }
        catch (error) {
            return handleError(error, "getInvoice");
        }
    }



    async createInvoiceFromRegistration(invoices: ICreateInvoiceFromRegistration[]): Promise<IResult<number[]>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/Invoice/CreateInvoiceFromRegistrations`);
            const response = await axios.post(url, invoices);
            return response.data as IResult<number[]>;
        }
        catch (error) {
            return handleError(error, "createInvoiceFromRegistration");
        }
    }

    async createInvoice(invoices: IEditInvoice): Promise<IResult<number>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/Invoice/CreateInvoice`);
            const response = await axios.post(url, invoices);
            return response.data as IResult<number>;
        }
        catch (error) {
            return handleError(error, "createInvoice");
        }
    }

    async updateInvoice(id:number,invoices: IEditInvoice): Promise<IResult<number>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/Invoice/UpdateInvoice/${id}`);
            const response = await axios.post(url, invoices);
            return response.data as IResult<number>;
        }
        catch (error) {
            return handleError(error, "createInvoice");
        }
    }

    async sendInvoiceEmail(invoices: number[]): Promise<IResult<number[]>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/Invoice/SendInvoiceEmail`);
            const response = await axios.post(url, invoices);
            return response.data as IResult<number[]>;
        }
        catch (error) {
            return handleError(error, "sendInvoiceEmail");
        }
    }

    async getInvoiceItems(id: number): Promise<IResult<IInvoiceItem[]>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/Invoice/${id}/GetInvoiceItems`);
            const response = await axios.get(url);
            const res = response.data as IResult<IInvoiceItem[]>;
           return Result.ok(res.data);
        }
        catch (error) {
            return handleError(error, "getInvoiceItems");
        }
    }

    async addInvoiceItem(id: number, item: IInvoiceItem[]): Promise<IResult<boolean>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/Invoice/addInvoiceItem/${id}`);
            const response = await axios.post(url, item);
            return response.data as IResult<boolean>;
        }
        catch (error) {
            return handleError(error, "addInvoiceItem");
        }
    }

    async updateInvoiceItem(id: number, item: IInvoiceItem): Promise<IResult<boolean>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/Invoice/UpdateInvoiceItem/${id}/item/${item.id}`);
            const response = await axios.post(url, item);
            return response.data as IResult<boolean>;
        }
        catch (error) {
            return handleError(error, "updateInvoiceItem");
        }
    }

    async removeInvoiceItem(id: number, itemId: number): Promise<IResult<boolean>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/Invoice/RemoveInvoiceItem/${id}/item/${itemId}`);
            const response = await axios.delete(url);
            return response.data as IResult<boolean>;
        }
        catch (error) {
            return handleError(error, "removeInvoiceItem");
        }
    }

    async createInvoiceStorno(invoiceId: number): Promise<IResult<null>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/Invoice/CreateInvoiceStorno/${invoiceId}`);
            const response = await axios.post(url);
            return response.data as IResult<null>;
        }
        catch (error) {
            return handleError(error, "createInvoiceStorno");
        }
    }

    async cancelInvoiceStorno(invoiceId: number): Promise<IResult<null>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/Invoice/CancelInvoiceStorno/${invoiceId}`);
            const response = await axios.post(url);
            return response.data as IResult<null>;
        }
        catch (error) {
            return handleError(error, "cancelInvoiceStorno");
        }
    }

}